goog.require('el8.template.multiuser_access.error');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.error = (function() {

    var that = {};

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */
        
         
        if (spec.urls) { el8.service.urls.init(spec.urls); }
        
        
        $('.main-content').html(
            el8.template.multiuser_access.error.content({})
        );
    };  

    return that;

})();